import { extendTheme } from "@chakra-ui/react";

export const theme = extendTheme({
  colors: {
    bg: "#000", //background
    text: "#ffffff", // cor do texto
    gray: "#383838", //cinza escuro
    gray_light: "#c0c0c0", // cinza claro
    green_primary: "#00ff12", // verde
  },
  // colors: {
  //     "bg": "#16171b", //background
  //     "text": "#fdfdfd", // cor do texto
  //     "gray": "#32363c", //cinza escuro
  //     "gray_light": "#7f8489", // cinza claro
  //     "red": "#C04549", // vermelho
  // },
  fonts: {
    body: "Lato",
    poppins: "Poppins",
    roboto: "Roboto",
  },
  styles: {
    global: {
      body: {
        bg: "bg",
      },
    },
  },
});
